export default "__VITE_ASSET__C0vCSBw4__"